import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export class FormRelationalValidators {
  static matchControls(
    checkControlName = 'password',
    confirmControlName = 'confirmPassword'
  ): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
      const checkControl = control.get(checkControlName);
      const confirmControl = control.get(confirmControlName);

      if (!checkControl || !confirmControl) {
        return null;
      }

      // Prevent overwriting other errors on confirmControl
      if (confirmControl.errors && !confirmControl.errors['valueMismatch']) {
        return null;
      }

      if (checkControl.value !== confirmControl.value) {
        confirmControl.setErrors({ valueMismatch: true });
      } else {
        confirmControl.setErrors(null);
      }

      return null;
    };
  }
}
